import isObjectEmpty from 'src/util/isEmptyObject';
import { Card, CardContent } from '@mui/material';

export default function AddressDisplay({ address }) {
  return (
    <Card className={'col-span-1'}>
      <CardContent>
        <div className=" font-medium">Address:</div>

        {!isObjectEmpty(address) && (
          <div className="ml-2">
            <p data-cy={'street'}>{address.street}</p>
            <p data-cy={'city-state-zip'}>
              {address.city}
              {address.city && address.state && ','} {address.state} {address.zip}
            </p>
          </div>
        )}
        <div className={isObjectEmpty(address) ? 'text-red-600' : ''}>
          {isObjectEmpty(address) && `No Address Provided`}
        </div>
      </CardContent>
    </Card>
  );
}
